import { supabase } from "@/lib/supabase";
import { readWorkspaceOrgIdFromStorage } from "@/lib/workspaceOrgStorage";
import type { ActivityTimelineQuery, ActivityTimelineResponse } from "@/lib/activityTimeline/types";

export type ActivityTimelineFetchResult =
  | { ok: true; status: number; data: ActivityTimelineResponse }
  | { ok: false; status: number; error: string; body?: unknown };

const ACTIVITY_TIMELINE_ACTION = "/api/admin/action?action=activity-timeline";

export async function queryActivityTimeline(
  query: ActivityTimelineQuery
): Promise<ActivityTimelineFetchResult> {
  if (!supabase) {
    return { ok: false, status: 503, error: "App is not configured for sign-in." };
  }
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) return { ok: false, status: 401, error: "Sign in required." };

  const headers: HeadersInit = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
  const ws = readWorkspaceOrgIdFromStorage();
  if (ws) (headers as Record<string, string>)["X-Workspace-Organization-Id"] = ws;

  const r = await fetch(ACTIVITY_TIMELINE_ACTION, {
    method: "POST",
    headers,
    body: JSON.stringify(query),
  });
  const text = await r.text();
  let json: unknown = null;
  try {
    json = JSON.parse(text);
  } catch {
    // non-json
  }
  if (!r.ok) {
    const err =
      json && typeof json === "object" && json !== null && "error" in json && typeof (json as { error: unknown }).error === "string"
        ? (json as { error: string }).error
        : text || `HTTP ${r.status}`;
    return { ok: false, status: r.status, error: err, body: json ?? undefined };
  }
  return { ok: true, status: r.status, data: json as ActivityTimelineResponse };
}
